import React from 'react';
import { List, Modal, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ActivityLogInterface, ModuleTableEnum } from '../../../types/activityLog';
import { ACTIVITY_LOG } from '../../../constants/define/translation';
import {
  toConvertTitleActivity,
  toDifferentChangedOther,
  toDifferentChangedTourTrash,
} from '../../../utils/transfer/activity';
import { appStyles } from '../../../styles';

interface DetailActivityLogModalProps {
  isOpenModal?: boolean;
  record?: ActivityLogInterface;
  onClose?: () => void;
}

const { Title } = Typography;

export const DetailActivityLogModal = (props: DetailActivityLogModalProps) => {
  const { t } = useTranslation(ACTIVITY_LOG);
  const { record, isOpenModal, onClose } = props;

  const title = toConvertTitleActivity(record?.module, record?.nextColumnValue);

  let data;
  if (record?.module === ModuleTableEnum.TOUR_TRASH) {
    data = toDifferentChangedTourTrash(record?.prevColumnValue, record?.nextColumnValue, []);
  } else {
    data = toDifferentChangedOther(record?.prevColumnValue, record?.nextColumnValue, []);
  }
  return (
    <StyledModal
      title={t('detail')}
      centered
      visible={isOpenModal}
      width={1024}
      footer={null}
      onCancel={onClose}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
    >
      <Title level={5}>{title}</Title>
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item: any) => (
          <List.Item>
            <List.Item.Meta title={item.title} description={item.description} />
          </List.Item>
        )}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .ant-modal-body {
    min-height: 40vh;
  }

  .ant-list-item-meta-description {
    color: #000000b8;
    font-size: 12px;
  }

  .ant-list-item-meta-title {
    font-weight: bold;
    font-size: 15px;
  }

  .ant-list ant-list-split {
    overflow-y: auto;
    height: 520px;
  }
`;
